'use client'

import { useEffect } from 'react'
import { Button } from '@dd3tech/wiggui/Button'
import { GoogleIcon } from '@dd3tech/wiggui/GoogleIcon'
import { Input } from '@dd3tech/wiggui/Input'
import { Modal } from '@dd3tech/wiggui/Modal'
import { useModalAddList } from '../hooks/useModalAddList'
import { ContainerLists } from './ContainerLists'
import { useModalAddListStore } from '../../../store'

export const ModalAddList = () => {
  const {
    createNewList,
    handleOnClick,
    modalAddListIsOpen,
    nameNewList,
    onClose,
    searchValue,
    setNameNewList,
    setSearchValue,
    showStepCreateNewList,
    debounceSearchValue,
    getLists
  } = useModalAddList()

  const isLoading = useModalAddListStore((state) => state?.isLoading)

  const isLoadingCreateNewList = useModalAddListStore(
    (state) => state?.isLoadingCreateNewList
  )
  const setShowStepCreateNewList = useModalAddListStore(
    (state) => state?.setShowStepCreateNewList
  )

  useEffect(() => {
    if (
      (!debounceSearchValue || debounceSearchValue?.length > 0) &&
      !showStepCreateNewList
    ) {
      getLists({ page: 1 })
    }
  }, [debounceSearchValue])

  if (!modalAddListIsOpen) {
    return null
  }

  return (
    <Modal
      className="w-full max-w-lg"
      enableBgBlur
      onClose={isLoading ? () => ({}) : onClose}
      isOpen={modalAddListIsOpen}
    >
      <Modal.Header
        title={
          showStepCreateNewList
            ? 'Crear nueva lista pública'
            : 'Añadir a lista pública'
        }
        isShowCloseButton
        isShowDivider
      />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-center justify-center">
        {showStepCreateNewList ? (
          <Input
            name="name-list"
            value={nameNewList}
            onChange={(event) => setNameNewList(event?.target.value)}
            className="w-full"
            height="h-[52px]"
            classNameContainer="w-full"
            classNameLabel="text-secondary"
            labelText="Nombre de la lista"
          />
        ) : (
          <Input
            name="search-list"
            value={searchValue}
            onChange={(event) => {
              if (event.target.value.length === 0) {
                setSearchValue(undefined)
                return
              }

              setSearchValue(event?.target.value)
            }}
            className="w-full"
            height="h-[52px]"
            classNameContainer="w-full"
            classNameLabel="text-secondary"
            labelText="Buscar lista"
            leftIcon={
              <GoogleIcon name="search" className="text-primary text-[24px]" />
            }
          />
        )}
        {!showStepCreateNewList && <ContainerLists />}
      </Modal.Body>
      <Modal.Footer
        className="w-full py-[9px] px-6 flex flex-row items-center justify-between gap-3"
        isShowDivider
      >
        {showStepCreateNewList ? (
          <>
            <Button
              isLoading={isLoadingCreateNewList}
              isDisabled={isLoadingCreateNewList}
              onClick={onClose}
              variant="terciary"
              fullWidth
            >
              Cancelar
            </Button>
            <Button
              isLoading={isLoadingCreateNewList}
              isDisabled={isLoadingCreateNewList || nameNewList?.length < 2}
              onClick={createNewList}
              variant="secondary"
              className="min-w-[150px]"
              fullWidth
            >
              Crear
            </Button>
          </>
        ) : (
          <>
            <Button
              isLoading={isLoading}
              isDisabled={isLoading}
              onClick={() => setShowStepCreateNewList(true)}
              variant="link"
            >
              Nueva lista
            </Button>
            <Button
              isLoading={isLoading}
              isDisabled={isLoading}
              onClick={handleOnClick}
              variant="secondary"
              className="min-w-[150px]"
            >
              Listo
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  )
}
